import { DgtPdOrderPicklist } from '../../models'
import Modal from '../Modal'
import DataGrid, { 
  SelectColumn
} from 'react-data-grid'
import { useState } from 'react'
import { writeFile, utils } from 'xlsx';

import CheckboxFormatter from '../../formatters/CheckboxFormatter'
import { PicklistStatus, PicklistStatusDesc } from '../../constants/EnumType';
import { formatDateFromUnix } from '../../utilities/Format';

const GenerateExcelFGModal = ({ 
  show, onClose, status, fgOrders, filename, divison, dateRange
} : { 
  show: boolean,
  onClose: () => void,
  status: string,
  divison: string,
  dateRange: string,
  fgOrders: DgtPdOrderPicklist[],
  filename: string
}) => {
  
  const [selectedRows, setSelectedRows] = useState<ReadonlySet<string>>(() => new Set(
    fgOrders.map(ord => ord.extraReturnId ? `${ord.pk}-${ord.extraReturnId}` : ord.pk)
  ));
  const [ loading, setLoading ] = useState<boolean>(false)

  const exportFGtoExcel = async () => {
    setLoading(true)

    const workbook = utils.book_new();
    
    const selectedOrders = fgOrders.filter(ord => Array.from(selectedRows).includes(ord.pk))
    let excelItems = []
    for (const ord of selectedOrders) {
      excelItems.push(
        {
          'Order': ord.pk,
          'Material Code': ord.materialCode,
          'Material Description': ord.materialDescription,
          'Qty': ord.orderQty,
          'Unit': ord.materialUnit,
          'Division': ord.division,
          'BatchLot': ord.batchLotNo,
          'RequestedBy': ord.requestedBy,
          'RequestedDate': formatDateFromUnix(ord.requestedDateTime),
          'Comment': ord.commentText
        }
      )
      if (status === PicklistStatus.WH_SHORTAGE) {
        const shortageItems: DgtPdOrderPicklist[] = ord.shortageItems ? JSON.parse(ord.shortageItems) : []
        excelItems.push(...shortageItems.map(itm => ({
          'Order': '',
          'Material Code': '',
          'Material Description': '',
          'Qty': '',
          'Unit': '',
          'Division': '',
          'BatchLot': '',
          'RequestedBy': '',
          'RequestedDate': '',
          'Comment': '',
          'Shortage Code': itm.materialCode,
          'Shortage Desc': itm.materialDescription,
          'Current Qty': itm.withdrawQty,
          'Expect Qty': itm.requestQty,
          'Sht Unit': itm.materialUnit
        })))
      }
    }
    const worksheet = utils.json_to_sheet(excelItems)

    worksheet["!cols"] = [
      { wch: 10 },
      { wch: 12 },
      { wch: 40 },
      { wch: 10 },
      { wch: 5 },
      { wch: 10 },
      { wch: 30 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 15 },
      { wch: 40 }
    ];
    
    utils.book_append_sheet(workbook, worksheet, getValueByKeyForStringEnum(status));
    
    writeFile(workbook, `FG_${filename}.xlsx`);

    setLoading(false)
    
    onClose()
  }

  return show ? <Modal
    title={`Export รายการ Order สถานะ "${getValueByKeyForStringEnum(status)}"`}
    maxWidth={'max-w-2xl'}
    show={show}
    onHide={onClose}>
    <div className='space-y-3 '>
      <div className='grid grid-cols-3 '>
        <p className='font-bold '>วันที่</p>
        <p className='col-span-2 '>
          {dateRange}
        </p>
        <p className='font-bold '>แผนก</p>
        <p className='col-span-2 '>
          {divison}
        </p>
        <p className='font-bold '>ทั้งหมด</p>
        <p className='col-span-2 '>{selectedRows.size} order(s)</p>
      </div>
      <DataGrid
        columns={[ 
          SelectColumn, 
          { key: 'pk', name: 'Order', width: 100 },
          { key: 'materialCode', name: 'Code', width: 100 },
          { key: 'materialDescription', name: 'Description' },
          { key: 'commentText', 'name': 'Note', width: 80 }
        ]}
        rows={fgOrders}
        style={{ height: 'fit-content' }}
        selectedRows={selectedRows}
        onSelectedRowsChange={setSelectedRows}
        rowKeyGetter={row => row.extraReturnId ? `${row.pk}-${row.extraReturnId}` : row.pk}
        components={{ checkboxFormatter: CheckboxFormatter }}
      />
      <div className="flex w-full gap-2 pt-4">
        <button
          type="button"
          className={` btn-outline-secondary basis-1/2`}
          onClick={onClose}
        >
          ยกเลิก
        </button>
        <button
          type="submit"
          className='btn-success basis-1/2'
          onClick={exportFGtoExcel}
          disabled={loading}
        >
          {loading ? `Loading...`: 'Export'}
        </button>
      </div>
    </div>
  </Modal> : null
}

function getValueByKeyForStringEnum(value: string) {
  if (value === '') return 'ไม่ระบุ'
  return Object.entries(PicklistStatusDesc).find(([key, val]) => key === value)?.[1] || value;
}


export default GenerateExcelFGModal